import type { ImageFilters } from '../entities/element'

/**
 * Image Filter Preset Enum
 * Used for type-safe preset selection and translation keys
 */
export enum FilterPreset {
  NONE = 'none',
  BW = 'bw',
  SEPIA = 'sepia',
  VINTAGE = 'vintage',
  VIBRANT = 'vibrant',
  COOL = 'cool',
  WARM = 'warm',
}

/**
 * Image Filter Presets
 * Predefined filter combinations for common effects
 */
export const FILTER_PRESETS: Record<FilterPreset, ImageFilters> = {
  [FilterPreset.NONE]: {
    brightness: 100,
    contrast: 100,
    saturation: 100,
    blur: 0,
    sepia: 0,
    hueRotate: 0,
  },
  [FilterPreset.BW]: {
    brightness: 100,
    contrast: 110,
    saturation: 0, // Grayscale
    blur: 0,
    sepia: 0,
    hueRotate: 0,
  },
  [FilterPreset.SEPIA]: {
    brightness: 105,
    contrast: 105,
    saturation: 80,
    blur: 0,
    sepia: 100, // Full sepia
    hueRotate: 0,
  },
  [FilterPreset.VINTAGE]: {
    brightness: 95,
    contrast: 110,
    saturation: 70,
    blur: 0.5,
    sepia: 40,
    hueRotate: 0,
  },
  [FilterPreset.VIBRANT]: {
    brightness: 105,
    contrast: 115,
    saturation: 150, // Extra saturated
    blur: 0,
    sepia: 0,
    hueRotate: 0,
  },
  [FilterPreset.COOL]: {
    brightness: 100,
    contrast: 100,
    saturation: 110,
    blur: 0,
    sepia: 0,
    hueRotate: 200, // Blue shift
  },
  [FilterPreset.WARM]: {
    brightness: 105,
    contrast: 100,
    saturation: 110,
    blur: 0,
    sepia: 0,
    hueRotate: 20, // Orange shift
  },
}

export const DEFAULT_FILTERS: ImageFilters = FILTER_PRESETS[FilterPreset.NONE]
